import React, { useState, useEffect } from 'react';
import MySelect from '../MySelect/MySelect';
import { fetchCarrierByCode } from '../../services/api';
import MessageBox from '../MessageBox/MessageBox';
import './duplicationComponent.css';

const DuplicationComponent = ({
  carrierCodes,
  carrier,
  carrier_price,
  carrier_emails,
  carrier_email,
  pickup_data,
  delivery_data,
  onClose,
  onConfirm,
}) => {
  const getCurrentDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const [duplicationType, setDuplicationType] = useState('simple');
  const [pickupDate, setPickupDate] = useState({
    pickup_day_when: 'LE',
    pickup_date: '',
    pickup_time_when: 'AVANT',
    pickup_hour: '',
  });
  const [deliveryDate, setDeliveryDate] = useState({
    delivery_day_when: 'LE',
    delivery_date: '',
    delivery_time_when: 'AVANT',
    delivery_hour: '',
  });
  const [pickupTime, setPickupTime] = useState({
    pickup_time_when: 'AVANT',
    pickup_hour: '',
  });
  const [deliveryTime, setDeliveryTime] = useState({
    delivery_time_when: 'AVANT',
    delivery_hour: '',
  });
  const [daysToArrive, setDaysToArrive] = useState('');
  const [periodicity, setPeriodicity] = useState('daily');
  const [daysOfWeek, setDaysOfWeek] = useState([]);
  const [carrierMgtType, setCarrierMgtType] = useState('fill');
  const [carrierData, setCarrierData] = useState({
    selected_carrier: carrier,
    carrier_price: carrier_price,
    carrier_email: carrier_email,
  });
  const [carrierEmails, setCarrierEmails] = useState(carrier_emails);
  const [startDateRecurrence, setStartDateRecurrence] = useState(getCurrentDate());
  const [endTypeRecurrence, setEndTypeRecurrence] = useState('end-date');
  const [endDateRecurrence, setEndDateRecurrence] = useState('');
  const [numberOfOccurrences, setNumberOfOccurrences] = useState('');
  const [invertAddresses, setInvertAddresses] = useState(false);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageBoxConfig, setMessageBoxConfig] = useState({
    message: '',
    type: 'ok',
    onConfirm: null,
    onCancel: () => setShowMessageBox(false),
    onClose: () => setShowMessageBox(false),
    loading_button: false,
    input: false,
  });

  useEffect(() => {
    if (duplicationType === 'dates') {
      const newPickupDate = {
        ...pickupDate,
        pickup_day_when: pickup_data.pickup_day_when,
        pickup_time_when: pickup_data.pickup_time_when,
        pickup_hour: pickup_data.pickup_hour,
      };
      setPickupDate(newPickupDate);
      const newDeliveryDate = {
        ...deliveryDate,
        delivery_day_when: delivery_data.delivery_day_when,
        delivery_time_when: delivery_data.delivery_time_when,
        delivery_hour: delivery_data.delivery_hour,
      };
      setDeliveryDate(newDeliveryDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duplicationType]);

  useEffect(() => {
    const fetchCarrierEmails = async selectedCarrier => {
      try {
        const fetchedData = await fetchCarrierByCode(selectedCarrier);
        let newCarrierEmails = [];
        if (fetchedData['establishment_email'] !== '') {
          if (!newCarrierEmails.includes(fetchedData['establishment_email'])) {
            newCarrierEmails.push(fetchedData['establishment_email']);
          }
        }
        if (fetchedData['billing_email'] !== '') {
          if (!newCarrierEmails.includes(fetchedData['billing_email'])) {
            newCarrierEmails.push(fetchedData['billing_email']);
          }
        }
        if (fetchedData['email_book'] !== '') {
          const email_book = fetchedData['email_book'].split(',');
          email_book.forEach(async email => {
            newCarrierEmails.push(email);
          });
        }
        if (newCarrierEmails.length > 1) {
          newCarrierEmails = newCarrierEmails.filter(str => str !== '');
        }
        setCarrierEmails(newCarrierEmails);
      } catch (error) {
        console.error('Erreur lors de la récupération du dossier:', error);
      }
    };

    if (carrierData.selected_carrier) {
      fetchCarrierEmails(carrierData.selected_carrier);
    } else {
      setCarrierData({ ...carrierData, carrier_email: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carrierData.selected_carrier]);

  useEffect(() => {
    setCarrierData(prev => ({ ...prev, carrier_email: carrierEmails ? carrierEmails[0] : '' }));
  }, [carrierEmails]);

  useEffect(() => {
    if (endTypeRecurrence === 'end-date') {
      setNumberOfOccurrences('');
    } else {
      setEndDateRecurrence('');
    }
  }, [endTypeRecurrence]);

  const handleTypeChange = event => {
    setDuplicationType(event.target.value);
  };

  const validateFields = () => {
    let isValid = true;
    let newInvalidFields = [];

    if (duplicationType === 'simple') {
      isValid = true;
    } else if (duplicationType === 'dates') {
      if (pickupDate.pickup_date && deliveryDate.delivery_date) {
        if (!(pickupDate.pickup_date <= deliveryDate.delivery_date)) {
          isValid = false;
          newInvalidFields.push(
            "Dates: la date d'enlèvement doit être antérieure à la date de livraison."
          );
        }
      } else {
        isValid = false;
        newInvalidFields.push(
          "Dates: les dates d'enlèvement et de livraison doivent être renseignées."
        );
      }
    } else if (duplicationType === 'recurrence') {
      if (!daysToArrive) {
        isValid = false;
        newInvalidFields.push('Temps de livraison: ce champ doit être renseigné.');
      }
      if (periodicity === 'weekly' && daysOfWeek.length === 0) {
        isValid = false;
        newInvalidFields.push('Périodicité hebdo: au moins 1 jour doit être sélectionné.');
      }
      if (carrierMgtType === 'fill') {
        if (
          !carrierData.selected_carrier ||
          !carrierData.carrier_price ||
          !carrierData.carrier_email
        ) {
          isValid = false;
          newInvalidFields.push('Affectation transporteur: les 3 champs doivent être renseignés.');
        }
      }
      if (!startDateRecurrence) {
        isValid = false;
        newInvalidFields.push('Date de début: ce champ doit être renseigné.');
      } else if (endTypeRecurrence === 'end-date' && !endDateRecurrence) {
        isValid = false;
        newInvalidFields.push('Date de fin: ce champ doit être renseigné.');
      } else if (endTypeRecurrence === 'end-date' && endDateRecurrence < startDateRecurrence) {
        isValid = false;
        newInvalidFields.push(
          'Dates récurrence: la date de début doit être antérieure à la date de fin.'
        );
      } else if (endTypeRecurrence === 'occurences' && !numberOfOccurrences) {
        isValid = false;
        newInvalidFields.push("Nombre d'occurences: ce champ doit être renseigné.");
      }
    }

    if (newInvalidFields.length > 0) {
      setMessageBoxConfig({
        message: `Plusieurs erreurs ont été détectées: ${newInvalidFields.join('\n')}`,
        type: 'ok',
        loading_button: false,
        input: false,
        onConfirm: () => setShowMessageBox(false),
        onCancel: () => setShowMessageBox(false),
      });
      setShowMessageBox(true);
    }

    return isValid;
  };

  const handleChangePickupDate = e => {
    const { name, value } = e.target;
    setPickupDate({
      ...pickupDate,
      [name]: value,
    });
  };

  const handleChangeDeliveryDate = e => {
    const { name, value } = e.target;
    setDeliveryDate({
      ...deliveryDate,
      [name]: value,
    });
  };

  const handleChangePickupTime = e => {
    const { name, value } = e.target;
    setPickupTime({
      ...pickupTime,
      [name]: value,
    });
  };

  const handleChangeDeliveryTime = e => {
    const { name, value } = e.target;
    setDeliveryTime({
      ...deliveryTime,
      [name]: value,
    });
  };

  const handleCheckboxChange = day => {
    setDaysOfWeek(prevDays =>
      prevDays.includes(day) ? prevDays.filter(d => d !== day) : [...prevDays, day]
    );
  };

  const handleInvertCheckboxChange = () => {
    setInvertAddresses(!invertAddresses);
  };

  const handleEndTypeRecurrenceChange = event => {
    setEndTypeRecurrence(event.target.value);
  };

  const handleCarrierMgtTypeChange = event => {
    setCarrierMgtType(event.target.value);
  };

  const handleChangeEndDateRecurrence = event => {
    if (event.target.value) {
      setEndTypeRecurrence('end-date');
    }
    setEndDateRecurrence(event.target.value);
  };

  const handleChangeNumberOfOccurences = event => {
    if (event.target.value) {
      setEndTypeRecurrence('occurences');
    }
    setNumberOfOccurrences(event.target.value);
  };

  const handleSubmit = () => {
    if (validateFields()) {
      const data = {
        duplicationType,
        invertAddresses,
        pickupDate: duplicationType === 'dates' ? pickupDate : undefined,
        deliveryDate: duplicationType === 'dates' ? deliveryDate : undefined,
        pickupTime: duplicationType === 'recurrence' ? pickupTime : undefined,
        deliveryTime: duplicationType === 'recurrence' ? deliveryTime : undefined,
        daysToArrive: duplicationType === 'recurrence' ? daysToArrive : undefined,
        periodicity: duplicationType === 'recurrence' ? periodicity : undefined,
        daysOfWeek:
          duplicationType === 'recurrence' && periodicity === 'weekly' ? daysOfWeek : undefined,
        carrierMgtType: duplicationType === 'recurrence' ? carrierMgtType : undefined,
        carrierData: duplicationType === 'recurrence' ? carrierData : undefined,
        numberOfOccurrences:
          duplicationType === 'recurrence' && endDateRecurrence === ''
            ? numberOfOccurrences
            : undefined,
        startDateRecurrence: duplicationType === 'recurrence' ? startDateRecurrence : undefined,
        endDateRecurrence: duplicationType === 'recurrence' ? endDateRecurrence : undefined,
      };
      onConfirm(data);
    }
  };

  return (
    <div className="overlay">
      <div className="duplication-component-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <div className="duplication-type-container">
          <label>
            <input
              type="radio"
              value="simple"
              checked={duplicationType === 'simple'}
              onChange={handleTypeChange}
            />
            Duplication simple en copiant les dates d'enl et liv
          </label>
          <label>
            <input
              type="radio"
              value="dates"
              checked={duplicationType === 'dates'}
              onChange={handleTypeChange}
            />
            Duplication simple avec choix des dates pour la copie du dossier
          </label>
          <label>
            <input
              type="radio"
              value="recurrence"
              checked={duplicationType === 'recurrence'}
              onChange={handleTypeChange}
            />
            Duplication avec récurrence
          </label>
        </div>

        <div className="duplication-invert-addresses">
          <label>
            <input
              type="checkbox"
              checked={invertAddresses}
              onChange={handleInvertCheckboxChange}
            />
            Inverser les adresses du dossier en cours
          </label>
        </div>

        {duplicationType === 'dates' && (
          <div className="duplication-dates-container">
            <p>Nouvelle date d'enlèvement:</p>
            <div className="duplication-dates-pickup">
              <select
                name="pickup_day_when"
                value={pickupDate.pickup_day_when}
                onChange={handleChangePickupDate}
              >
                <option>LE</option>
                <option>A PARTIR DU</option>
              </select>
              <div className="vertical-input-group">
                <input
                  type="date"
                  name="pickup_date"
                  value={pickupDate.pickup_date}
                  onChange={handleChangePickupDate}
                />
              </div>
              <div className="supp-element">
                <select
                  name="pickup_time_when"
                  value={pickupDate.pickup_time_when}
                  onChange={handleChangePickupDate}
                >
                  <option>A</option>
                  <option>AVANT</option>
                  <option>APRES</option>
                  <option>ENTRE</option>
                </select>
              </div>
              <div className="vertical-input-group">
                <label>Heure:</label>
                <input
                  type="text"
                  name="pickup_hour"
                  value={pickupDate.pickup_hour}
                  onChange={handleChangePickupDate}
                />
              </div>
            </div>
            <p>Nouvelle date de livraison:</p>
            <div className="duplication-dates-delivery">
              <select
                name="delivery_day_when"
                value={deliveryDate.delivery_day_when}
                onChange={handleChangeDeliveryDate}
              >
                <option>LE</option>
                <option>A PARTIR DU</option>
              </select>
              <div className="vertical-input-group">
                <input
                  type="date"
                  name="delivery_date"
                  value={deliveryDate.delivery_date}
                  onChange={handleChangeDeliveryDate}
                />
              </div>
              <div className="supp-element">
                <select
                  name="delivery_time_when"
                  value={deliveryDate.delivery_time_when}
                  onChange={handleChangeDeliveryDate}
                >
                  <option>A</option>
                  <option>AVANT</option>
                  <option>APRES</option>
                  <option>ENTRE</option>
                </select>
              </div>
              <div className="vertical-input-group">
                <label>Heure:</label>
                <input
                  type="text"
                  name="delivery_hour"
                  value={deliveryDate.delivery_hour}
                  onChange={handleChangeDeliveryDate}
                />
              </div>
            </div>
          </div>
        )}

        {duplicationType === 'recurrence' && (
          <div className="duplication-recurrence-container">
            <div className="duplication-recurrence-hours">
              <div className="duplication-recurrence-hours-grid">
                <div className="duplication-recurrence-hours-grid-pickup">
                  <p>Heure d'enlèvement:</p>
                  <div className="duplication-recurrence-hours-grid-group">
                    <div className="supp-element">
                      <select
                        name="pickup_time_when"
                        value={pickupTime.pickup_time_when}
                        onChange={handleChangePickupTime}
                      >
                        <option>A</option>
                        <option>AVANT</option>
                        <option>APRES</option>
                        <option>ENTRE</option>
                      </select>
                    </div>
                    <div className="vertical-input-group">
                      <label>Heure:</label>
                      <input
                        type="text"
                        name="pickup_hour"
                        value={pickupTime.pickup_hour}
                        onChange={handleChangePickupTime}
                      />
                    </div>
                  </div>
                </div>
                <div className="duplication-recurrence-hours-grid-delivery">
                  <p>Heure de livraison:</p>
                  <div className="duplication-recurrence-hours-grid-group">
                    <div className="supp-element">
                      <select
                        name="delivery_time_when"
                        value={deliveryTime.delivery_time_when}
                        onChange={handleChangeDeliveryTime}
                      >
                        <option>A</option>
                        <option>AVANT</option>
                        <option>APRES</option>
                        <option>ENTRE</option>
                      </select>
                    </div>
                    <div className="vertical-input-group">
                      <label>Heure:</label>
                      <input
                        type="text"
                        name="delivery_hour"
                        value={deliveryTime.delivery_hour}
                        onChange={handleChangeDeliveryTime}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="duplication-recurrence-hours-days-to-arrive horizontal-input-group">
                <label>Temps de livraison (jours):</label>
                <input
                  type="number"
                  name="days_to_arrive"
                  value={daysToArrive}
                  onChange={e => setDaysToArrive(e.target.value)}
                />
              </div>
            </div>
            <div className="duplication-recurrence-periodicity-container">
              <div className="duplication-recurrence-periodicity-content">
                <div className="duplication-recurrence-periodicity-selector">
                  <label>
                    Périodicité:
                    <select value={periodicity} onChange={e => setPeriodicity(e.target.value)}>
                      <option value="daily">Quotidienne</option>
                      <option value="weekly">Hebdomadaire</option>
                    </select>
                  </label>
                </div>
                {periodicity === 'weekly' && (
                  <div className="duplication-recurrence-periodicity-weekdays-container">
                    <div>
                      <label>
                        <input
                          type="checkbox"
                          checked={daysOfWeek.includes('Monday')}
                          onChange={() => handleCheckboxChange('Monday')}
                        />
                        Lundi
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={daysOfWeek.includes('Tuesday')}
                          onChange={() => handleCheckboxChange('Tuesday')}
                        />
                        Mardi
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={daysOfWeek.includes('Wednesday')}
                          onChange={() => handleCheckboxChange('Wednesday')}
                        />
                        Mercredi
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={daysOfWeek.includes('Thursday')}
                          onChange={() => handleCheckboxChange('Thursday')}
                        />
                        Jeudi
                      </label>
                    </div>
                    <div>
                      <label>
                        <input
                          type="checkbox"
                          checked={daysOfWeek.includes('Friday')}
                          onChange={() => handleCheckboxChange('Friday')}
                        />
                        Vendredi
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={daysOfWeek.includes('Saturday')}
                          onChange={() => handleCheckboxChange('Saturday')}
                        />
                        Samedi
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={daysOfWeek.includes('Sunday')}
                          onChange={() => handleCheckboxChange('Sunday')}
                        />
                        Dimanche
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="duplication-recurrence-carrier-data-container">
              <p>Affectation tps et montant:</p>
              <div className="duplication-recurrence-carrier-data-grid">
                <div className="duplication-recurrence-carrier-data-mgt-type">
                  <div className="duplication-radio-label-group">
                    <div>
                      <input
                        type="radio"
                        value="empty"
                        checked={carrierMgtType === 'empty'}
                        onChange={handleCarrierMgtTypeChange}
                      />
                    </div>
                    <label
                      onClick={() => handleCarrierMgtTypeChange({ target: { value: 'empty' } })}
                    >
                      Laisser transporteur et montant vides
                    </label>
                  </div>
                  <div className="duplication-radio-label-group">
                    <div>
                      <input
                        type="radio"
                        value="fill"
                        checked={carrierMgtType === 'fill'}
                        onChange={handleCarrierMgtTypeChange}
                      />
                    </div>
                    <label
                      onClick={() => handleCarrierMgtTypeChange({ target: { value: 'fill' } })}
                    >
                      Définir transporteur et montant
                    </label>
                  </div>
                </div>
                {carrierMgtType === 'fill' && (
                  <div className="duplication-recurrence-carrier-data-inputs">
                    <div className="duplication-recurrence-carrier-data-inputs-first-row">
                      <div className="duplication-recurrence-carrier-data-inputs-input-group">
                        <label>Transporteur:</label>
                        <MySelect
                          values={carrierCodes}
                          isCreatable={false}
                          value={
                            carrierData.selected_carrier
                              ? {
                                  value: carrierData.selected_carrier,
                                  label: carrierData.selected_carrier,
                                }
                              : null
                          }
                          onChange={selectedOption =>
                            setCarrierData({
                              ...carrierData,
                              selected_carrier: selectedOption ? selectedOption.value : '',
                            })
                          }
                          validationType="str"
                        />
                      </div>
                      <div className="duplication-recurrence-carrier-data-inputs-input-group">
                        <label>Montant:</label>
                        <input
                          type="number"
                          value={carrierData.carrier_price}
                          onChange={e =>
                            setCarrierData({ ...carrierData, carrier_price: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="duplication-recurrence-carrier-data-inputs-mail-row">
                      <select
                        name="carrier_email"
                        value={carrierData.carrier_email}
                        onChange={e =>
                          setCarrierData({ ...carrierData, carrier_email: e.target.value })
                        }
                      >
                        {carrierEmails.map((email, index) => (
                          <option key={index}>{email}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="duplication-recurrence-duration-container">
              <p>Durée:</p>
              <label>
                <div className="duplication-recurrence-duration-grid">
                  <div className="duplication-recurrence-duration-start">
                    <label>
                      Date de Début:
                      <input
                        type="date"
                        value={startDateRecurrence}
                        onChange={e => setStartDateRecurrence(e.target.value)}
                      />
                    </label>
                  </div>
                  <div className="duplication-recurrence-duration-end">
                    <div className="duplication-radio-label-group">
                      <div>
                        <input
                          type="radio"
                          value="end-date"
                          checked={endTypeRecurrence === 'end-date'}
                          onChange={handleEndTypeRecurrenceChange}
                        />
                      </div>
                      <label>
                        Fin le:
                        <input
                          type="date"
                          value={endDateRecurrence}
                          onChange={handleChangeEndDateRecurrence}
                        />
                      </label>
                    </div>
                    <div className="duplication-radio-label-group">
                      <div>
                        <input
                          type="radio"
                          value="occurences"
                          checked={endTypeRecurrence === 'occurences'}
                          onChange={handleEndTypeRecurrenceChange}
                        />
                      </div>
                      <label>
                        Fin après
                        <input
                          type="number"
                          value={numberOfOccurrences}
                          onChange={handleChangeNumberOfOccurences}
                        />
                        occurences
                      </label>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
        )}

        <button className="duplication-endbutton" onClick={handleSubmit}>
          Valider
        </button>
      </div>

      {showMessageBox && (
        <MessageBox
          message={messageBoxConfig.message}
          onClose={() => setShowMessageBox(false)}
          onConfirm={messageBoxConfig.onConfirm}
          onCancel={messageBoxConfig.onCancel}
          type={messageBoxConfig.type}
          loading_button={messageBoxConfig.loading_button}
          input={messageBoxConfig.input}
          technicalDetails={messageBoxConfig.technicalDetails}
        />
      )}
    </div>
  );
};

export default DuplicationComponent;
